import React from 'react';
import styles from './PasswordEdit.module.scss';

interface Props {
  Model?: any;
  PageData?: any;
  handleClick: Function;
  setEditPasswordResponseData: Function;
}

const PasswordEdit = ({
  handleClick,
  PageData,
  Model,
  setEditPasswordResponseData,
}: Props) => {
  const onSubmit = (e: any) => {
    handleClick(true);
    e.preventDefault();
  };
  return (
    <div className="cards-items">
      <div className="Customerdetails-card">
        <div className="Grid Grid--gutterHz Grid--gutterVz">
          <div className="Grid-cell">
            <div className="Customerdetails-Headerwrapper">
              <label className="Customerdetails-label">
                {PageData?.PasswordCardLabelText}
              </label>

              <div className="Customerdetails-button">
                <button
                  className="Button Button--ghost js-contact-edit-modal"
                  onClick={onSubmit}
                  disabled={Model?.IsGoogleOrAppleLogin}
                >
                  {PageData?.ResetPasswordButtonText}
                </button>
              </div>
            </div>

            <span className="Customerdetails-mail">
              {PageData?.PasswordNoteText}{' '}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordEdit;
